import { render, staticRenderFns } from "./OrderCardHeader.vue?vue&type=template&id=2957f448&scoped=true&"
import script from "./OrderCardHeader.vue?vue&type=script&lang=js&"
export * from "./OrderCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957f448",
  null
  
)

export default component.exports